import styled from "@emotion/styled";
import Menu from "@mui/material/Menu";
import { COLOR_WHITE } from "shared/theme/colors";

export const StyledDrawer = styled(Menu)`
  .MuiPaper-root {
    display: flex;
    flex-direction: column;
    width: 240px;
    background-color: ${COLOR_WHITE};
    overflow: hidden;
    box-shadow:
      0px 0px 1px 0px rgba(0, 0, 0, 0.1),
      0px 2px 16px 0px rgba(0, 0, 0, 0.1);
  }
`;
